<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="120px">

    <el-form-item label="订单编号">
      <el-input
        :value="form.fBillNo"
        disabled
        style="width: 100%"
      />
    </el-form-item>

    <el-form-item label="经销商名称" prop="fDistributorName">
      <el-input v-model="form.fDistributorName" disabled />
    </el-form-item>

    <el-form-item label="印章名称" prop="fSeal1ID">
      <el-select-ex
        v-model="form.fSeal1ID"
        url="Seal/SealEntry"
        label-field="fName"
        value-field="fid"
        @change="sealChange"
      />
      <p>
        <img
          v-if="form.fSealUrl"
          :src="form.fSealUrl"
          style="width: 150px"
        >
      </p>
    </el-form-item>
  </el-form>

</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        // fPrice_fh: [{ required: true, message: '必填项', trigger: 'change' }],
        // fDate_fh: [{ required: true, message: '必填项', trigger: 'change' }]

      }
    }
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = Object.assign({}, this.form)
          onValid(data)
        } else {
          return false
        }
      })
    },
    sealChange: function(item) {
      this.form.fSealUrl = item.pictureUrl
    }
  }
}
</script>

<style>

</style>
